import Avatar from "../Avatar";
import IMG from "../../constants/image";
import { Link, useLocation } from "react-router-dom";
import { LOCAL_STORAGE_KEY, PATH } from "../../constants";
import { setCookie } from "../../utils";
import cn from "classnames";
import merchantStore from "../../store/merchantStore";
import React, { useEffect, useState } from "react";
import Button from "../Common/Button";
import popupStore from "../../store/popupStore";
import Share from "../Share/Share";
import { text } from "../../constants/text";

const data = [
    {
        id: 1,
        title: 'Quản lý sản phẩm',
        icon: IMG.icon.boxBlack,
        to: PATH.MANAGING_PRODUCT
    },
    {
        id: 2,
        title: 'Quản lý đơn hàng',
        icon: IMG.icon.clipboardList,
        to: PATH.MANAGING_ORDER
    },
    {
        id: 3,
        title: 'Thông tin cửa hàng',
        icon: IMG.icon.storeBlack,
        to: PATH.STORE_INFO
    },
    {
        id: 4,
        title: 'Sổ địa chỉ',
        icon: IMG.icon.location,
        to: PATH.ADDRESS
    },
    {
        id: 5,
        title: text.shippingConfig,
        icon: IMG.icon.truckBlack,
        to: PATH.SHIPPING_CONFIG
    },
    {
        id: 6,
        title: 'Cài đặt tài khoản',
        icon: IMG.icon.userBlack,
        to: PATH.ACCOUNT_SETTING
    }
]

const Navbar = () => {
    const [activeNav, setActiveNav] = useState();
    const location = useLocation();
    const { pathname } = location || {};
    const { merchantProfile } = merchantStore() || {};
    const { setPopup } = popupStore() || {};
    const { avatar_url, description, owner_name, phone_number, merchant_name } = merchantProfile || {}

    useEffect(() => {
        const activeMenu = data.find((column) => {
            return (pathname).includes(column.to);
        })
        setActiveNav(activeMenu);

    }, [pathname])

    const handleLogout = () => {
        setPopup({
            isOpen: true,
            data: {
                title: 'Bạn muốn đăng xuất khỏi trang bán hàng?',
                image: IMG.popupUpdateStatus,
                accept: {
                    label: 'Quay lại',
                    action: () => setPopup({})
                },
                cancel: {
                    label: 'Đồng ý',
                    action: () => {
                        window.localStorage.removeItem(LOCAL_STORAGE_KEY.TOKEN)
                        setCookie('token-share', 'logout', 1)
                        window.location.href = PATH.LOGIN
                    }
                }
            }
        })
    }

    const renderPopupShare = () => {
        return (
            <Share />
        )
    }

    const onClickShare = () => {
        setPopup({
            isOpen: true,
            data: {
                customContent: renderPopupShare
            }
        })
    }

    return (
        <div className='flex flex-col items-center px-5'>
            <div className='-mb-10 mx-auto text-center z-10'>
                <Avatar image={avatar_url} description={description} viewOnly />
            </div>
            <div className='relative bg-[#F8C5181A] rounded-xl px-8 pt-12 pb-2.5 text-center'>
                <Link className='cursor-pointer' to={PATH.STORE_INFO + '?editing=true'}>
                    <div className='absolute right-4 top-3 flex items-center space-x-2 text-sm'>
                        <img className='w-4 h-4' src={IMG.icon.pencil} alt='pencil' />
                        <div>{text.edit}</div>
                    </div>
                </Link>
                <p className='font-bold'>{merchant_name || owner_name || phone_number || ''}</p>
                <p className='text-sm'>
                    {description || 'Mô tả ngắn về cửa hàng'}
                </p>
                <div className='flex gap-1 justify-center items-center mt-2.5 cursor-pointer' onClick={onClickShare}>
                    <p className='text-sm'>Chia sẻ</p>
                    <img src={IMG.icon.share} alt="share" />
                </div>
            </div>


            <div className='flex flex-col gap-2.5 w-full mt-5 bg-white'>
                {(data || []).map(item => {
                    if (item.disabled) {
                        return (
                            <div
                                key={item.to}
                                className={cn('flex justify-between items-center p-2.5 rounded-xl', item.disabled ? 'opacity-30' : 'hover:bg-[#F8C518]/20', activeNav?.id === item.id && 'bg-[#F8C518]')}>
                                <div className='flex justify-between items-center gap-2.5'>
                                    <img className='w-6 h-6' src={item.icon} alt="icon" />
                                    <p className='text-sm'>{item.title}</p>
                                </div>
                                <img className='items-end transform' src={IMG.icon.chevronRight} alt="arrowDown" />
                            </div>
                        )
                    }
                    return (
                        <Link className='cursor-pointer' to={item.to} key={item.to}>
                            <div
                                className={cn('flex justify-between items-center p-2.5 rounded-xl', item.disabled ? 'opacity-30' : 'hover:bg-[#F8C518]/20', activeNav?.id === item.id && 'bg-[#F8C518]')}>
                                <div className='flex justify-between items-center gap-2.5'>
                                    <img className='w-6 h-6' src={item.icon} alt="icon" />
                                    <p className='text-sm'>{item.title}</p>
                                </div>
                                <img className='items-end transform' src={IMG.icon.chevronRight} alt="arrowDown" />
                            </div>
                        </Link>
                    )
                })}

                <Button className='bg-[#FAFAFC] gap-3 text-[15px] hover:bg-[#F8C518]' onClick={handleLogout}>
                    <img src={IMG.icon.logout} alt="" />
                    Đăng xuất
                </Button>
            </div>
        </div>
    )
}

export default Navbar;
